export default __webpack_public_path__ + "static/media/japanese-mountain-retreat-banner.db10aa22.jpg";